export const Suffixes = {
    unreachable: '.unreachable',
    reachable: '.reachable',
    enabled: '.enabled',
    state: '.state',
    power: '.currentPower',
    totalPower: '.totalPower',
    temperature: '.temperature',
    lastDetected: '.lastDetected',
    noMotion: '.no_motion',
    reboot: '.reboot',
    soundType: '.sound',
    soundVolume: '.volume',
    soundDuration: '.duration'
};
